var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "refresh_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#refresh_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.038 19.5c-2.094 0-3.867-.726-5.32-2.18-1.453-1.452-2.18-3.225-2.18-5.319 0-2.093.727-3.866 2.18-5.32C8.17 5.227 9.944 4.5 12.038 4.5c1.17 0 2.276.26 3.32.78a7.106 7.106 0 012.603 2.2V5.25c0-.212.072-.39.216-.534a.726.726 0 01.534-.216c.213 0 .391.072.535.216a.726.726 0 01.215.534v4.462c0 .256-.086.47-.26.643a.875.875 0 01-.644.26h-4.461a.725.725 0 01-.535-.215.726.726 0 01-.215-.535c0-.213.072-.39.215-.534a.726.726 0 01.535-.216h3.2a5.884 5.884 0 00-2.193-2.281A5.888 5.888 0 0012.038 6c-1.667 0-3.083.583-4.25 1.75-1.167 1.167-1.75 2.583-1.75 4.25 0 1.667.583 3.083 1.75 4.25 1.167 1.167 2.583 1.75 4.25 1.75a5.855 5.855 0 003.192-.915 5.905 5.905 0 002.195-2.443.784.784 0 01.418-.381.797.797 0 01.562-.013.653.653 0 01.428.4.66.66 0 01-.02.577 7.448 7.448 0 01-2.742 3.109c-1.21.777-2.554 1.166-4.033 1.166z",
    fill: "#8E8E94"
  }))));
}
export default SvgRefresh;